// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar__AkVia {
  position: fixed;
  left: 50px;
  top: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: background 0.4s ease-in-out, transform 0.6s ease-out;
}
@media (max-width: 1420px) {
  .Navbar_navbar__AkVia {
    left: 40px;
  }
}
@media (max-width: 1060px) {
  .Navbar_navbar__AkVia {
    z-index: 100;
    inset: 0;
    box-sizing: border-box;
    padding: 70px 0 0px 0;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transform: translateX(-100%);
  }
  .Navbar_navbar__AkVia.Navbar_active__MLHq1 {
    transform: translateX(0);
    background-color: #F6F6F6;
  }
}
@media (max-width: 560px) {
  .Navbar_navbar__AkVia {
    align-items: flex-start;
  }
}
.Navbar_navbar__AkVia .Navbar_menu__dbeuV {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 17px;
}
@media (max-width: 560px) {
  .Navbar_navbar__AkVia .Navbar_menu__dbeuV {
    padding-left: 60px !important;
  }
}
.Navbar_navbar__AkVia .Navbar_menu__dbeuV li {
  font-family: "Beer money";
  font-weight: 400;
  list-style: none;
}
.Navbar_navbar__AkVia .Navbar_menu__dbeuV li a {
  cursor: pointer;
  font-size: 1.2rem;
  text-decoration: none;
  transition: 0.4s;
}
@media (max-width: 1060px) {
  .Navbar_navbar__AkVia .Navbar_menu__dbeuV li a {
    font-size: 2.5rem !important;
  }
}

.Navbar_navbar__AkVia li, .Navbar_navbar__AkVia a {
  color: #000;
}
.Navbar_navbar__AkVia li.Navbar_active__MLHq1 a {
  font-size: 1.7em !important;
  color: var(--red) !important;
}
@media (max-width: 1060px) {
  .Navbar_navbar__AkVia {
    font-size: 2rem !important;
  }
}

.Navbar_navbar__AkVia.Navbar_home__deZwp li, .Navbar_navbar__AkVia.Navbar_home__deZwp a {
  color: var(--white);
}
@media (max-width: 1060px) {
  .Navbar_navbar__AkVia.Navbar_home__deZwp li, .Navbar_navbar__AkVia.Navbar_home__deZwp a {
    color: #000;
  }
}

.Navbar_toggle__NsU1p.Navbar_top__wFNAL {
  background-color: transparent;
  box-shadow: none;
}
.Navbar_toggle__NsU1p.Navbar_top__wFNAL span {
  background-color: #fff;
}

.Navbar_toggle__NsU1p {
  display: none;
  z-index: 101;
  padding: 20px 15px 20px 15px;
  border-radius: 50%;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 15px;
  top: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  transition: 0.5s;
  background-color: #F6F6F6;
}
@media (max-width: 1060px) {
  .Navbar_toggle__NsU1p {
    display: inline-flex;
  }
}
.Navbar_toggle__NsU1p span {
  width: 35px;
  background-color: #222222;
  height: 4px;
  transition: 0.5s;
}

.Navbar_toggle__NsU1p.Navbar_active__MLHq1 span {
  background-color: var(--red);
}
.Navbar_toggle__NsU1p.Navbar_active__MLHq1 span:nth-child(1) {
  width: 20px;
  transform: rotate(-40deg) translate(-4px, 3px);
}
.Navbar_toggle__NsU1p.Navbar_active__MLHq1 span:nth-child(3) {
  width: 20px;
  transform: rotate(40deg) translate(-4px, -3px);
}

.Navbar_links_network__aDCFG {
  display: none;
}
@media (max-width: 890px) {
  .Navbar_links_network__aDCFG {
    overflow: hidden;
  }
  .Navbar_links_network__aDCFG ul {
    transition: 0.4s ease-out;
    transition-delay: 0.6s;
    opacity: 0;
    transform: translate(0, 30px);
  }
}

.Navbar_links_network__aDCFG.Navbar_active__MLHq1 {
  display: flex;
}
.Navbar_links_network__aDCFG.Navbar_active__MLHq1 ul {
  opacity: 1;
  transform: translate(0, 0);
}
.Navbar_links_network__aDCFG.Navbar_active__MLHq1 svg {
  fill: var(--red) !important;
}

.Navbar_navbar__AkVia a:hover {
  color: var(--red) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.module.scss"],"names":[],"mappings":"AACA;EACG,eAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gEAAA;AAAH;AAEG;EAXH;IAYM,UAAA;EACJ;AACF;AACG;EAfH;IAgBM,YAAA;IACA,QAAA;IACA,sBAAA;IACA,qBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,4BAAA;EAEJ;EAAI;IACG,wBAAA;IACA,yBAAA;EAEP;AACF;AACG;EAhCH;IAiCM,uBAAA;EAEJ;AACF;AACG;EACG,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;AACN;AACM;EANH;IAOM,6BAAA;EAEP;AACF;AAAM;EACG,yBAAA;EACA,gBAAA;EACA,gBAAA;AAET;AADS;EACG,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AAGZ;AADY;EANH;IAOM,4BAAA;EAIb;AACF;;AAIG;EACG,WAAA;AADN;AAIG;EACG,2BAAA;EACA,4BAAA;AAFN;AAKI;EAVJ;IAWM,0BAAA;EAFJ;AACF;;AAMG;EACG,mBAAA;AAHN;AAKM;EAHH;IAIM,WAAA;EAFP;AACF;;AAMA;EACG,6BAAA;EACA,gBAAA;AAHH;AAIG;EACG,sBAAA;AAFN;;AAMA;EACG,aAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;AAHH;AAKG;EAfH;IAgBM,oBAAA;EAFJ;AACF;AAIG;EACG,WAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AAFN;;AAQG;EACG,4BAAA;AALN;AAQG;EACG,WAAA;EACA,8CAAA;AANN;AASG;EACG,WAAA;EACA,8CAAA;AAPN;;AAYA;EACG,aAAA;AATH;AAWG;EAHH;IAIM,gBAAA;EARJ;EAUI;IACG,yBAAA;IACA,sBAAA;IAEA,UAAA;IACA,6BAAA;EATP;AACF;;AAaA;EACG,aAAA;AAVH;AAYG;EACG,UAAA;EACA,0BAAA;AAVN;AAaG;EACG,2BAAA;AAXN;;AAiBG;EACG,4BAAA;AAdN","sourcesContent":["\r\n.navbar {\r\n   position: fixed;\r\n   left: 50px;\r\n   top: 0;\r\n   bottom: 0;\r\n   height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   transition: background 0.4s ease-in-out, transform 0.6s ease-out;\r\n\r\n   @media (max-width: 1420px) {\r\n      left: 40px;\r\n   }\r\n\r\n   @media (max-width: 1060px) {\r\n      z-index: 100;\r\n      inset: 0;\r\n      box-sizing: border-box;\r\n      padding: 70px 0 0px 0;\r\n      overflow-y: auto;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      transform: translateX(-100%);\r\n\r\n      &.active {\r\n         transform: translateX(0);\r\n         background-color: #F6F6F6;\r\n      }\r\n   }\r\n\r\n   @media (max-width: 560px) {\r\n      align-items: flex-start;\r\n   }\r\n\r\n\r\n   .menu {\r\n      display: flex;\r\n      flex-direction: column;\r\n      padding: 0;\r\n      gap: 17px;\r\n\r\n      @media (max-width: 560px) {\r\n         padding-left: 60px !important;\r\n      }\r\n\r\n      li {\r\n         font-family: \"Beer money\";\r\n         font-weight: 400;\r\n         list-style: none;\r\n         a {\r\n            cursor: pointer;\r\n            font-size: 1.2rem;\r\n            text-decoration: none;\r\n            transition: 0.4s;\r\n\r\n            @media (max-width: 1060px) {\r\n               font-size: 2.5rem !important;\r\n            }\r\n         }\r\n      }\r\n   }\r\n}\r\n\r\n\r\n.navbar{\r\n   li, a {\r\n      color: #000;\r\n   }\r\n\r\n   li.active a{\r\n      font-size: 1.7em !important;\r\n      color: var(--red) !important; \r\n   }\r\n\r\n    @media (max-width: 1060px) {\r\n      font-size: 2rem !important;\r\n   }\r\n}\r\n\r\n.navbar.home{\r\n   li, a {\r\n      color: var(--white);\r\n\r\n      @media (max-width: 1060px) {\r\n         color: #000;\r\n      }\r\n   }\r\n}\r\n\r\n.toggle.top{\r\n   background-color: transparent;\r\n   box-shadow: none;\r\n   span{\r\n      background-color: #fff;\r\n   }\r\n}\r\n\r\n.toggle{\r\n   display: none;\r\n   z-index: 101;\r\n   padding: 20px 15px 20px 15px;\r\n   border-radius: 50%;\r\n   box-shadow: 0 0 7px rgba(0, 0, 0, 0.25);\r\n   position: fixed;\r\n   left: 15px;\r\n   top: 15px;\r\n   flex-direction: column;\r\n   align-items: flex-start;\r\n   gap: 7px;\r\n   transition: 0.5s;\r\n   background-color: #F6F6F6;\r\n\r\n   @media (max-width: 1060px) {\r\n      display: inline-flex;\r\n   }\r\n\r\n   span{\r\n      width: 35px;\r\n      background-color: #222222;\r\n      height: 4px;\r\n      transition: 0.5s;\r\n      // background-color: #fff;\r\n   }\r\n}\r\n\r\n.toggle.active{\r\n   span{\r\n      background-color: var(--red);\r\n   }\r\n\r\n   span:nth-child(1){\r\n      width: 20px;\r\n      transform: rotate(-40deg) translate(-4px, 3px);\r\n   }\r\n\r\n   span:nth-child(3){\r\n      width: 20px;\r\n      transform: rotate(40deg) translate(-4px, -3px);\r\n   }\r\n}\r\n\r\n\r\n.links_network{\r\n   display: none;\r\n   \r\n   @media (max-width: 890px) {\r\n      overflow: hidden;\r\n      \r\n      ul {\r\n         transition: 0.4s ease-out;\r\n         transition-delay: 0.6s;\r\n\r\n         opacity: 0;\r\n         transform: translate(0, 30px);\r\n      };\r\n   }\r\n}\r\n\r\n.links_network.active{\r\n   display: flex;\r\n   \r\n   ul {\r\n      opacity: 1;\r\n      transform: translate(0, 0);\r\n   };\r\n\r\n   svg {\r\n      fill: var(--red) !important;\r\n   }\r\n}\r\n\r\n\r\n.navbar{\r\n   a:hover{\r\n      color: var(--red) !important;\r\n   }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__AkVia`,
	"active": `Navbar_active__MLHq1`,
	"menu": `Navbar_menu__dbeuV`,
	"home": `Navbar_home__deZwp`,
	"toggle": `Navbar_toggle__NsU1p`,
	"top": `Navbar_top__wFNAL`,
	"links_network": `Navbar_links_network__aDCFG`
};
export default ___CSS_LOADER_EXPORT___;
